<template>
  <v-container fluid class="ma-4 px-8">
    <v-row>
      <v-col cols="12" md="3" class="py-0 my-0">
        <v-autocomplete
          v-model="form.misc_fee_ids"
          :items="feeTypes"
          outlined
          dense
          multiple
          chips
          hide-details="auto"
          label="Particular"
          item-text="text"
          item-value="id"
          @change="reportData = { fee: [], current_date: null }"
          clearable
          >
         <template v-slot:selection="{ item, index }">
            <div class="d-flex align-center">
              <v-chip
                v-if="index < 2"
                small
                class="mr-2 max-w-xl w-4"
                style="max-width:140px !important; margin: 2px"
                outlined
              >
                {{ item.text }}
              </v-chip>
              <span v-if="index === 2" class="text-caption ml-2">
                (+{{ form.misc_fee_ids.length - 2 }} others)
              </span>
            </div>
          </template>
        </v-autocomplete>
        
      </v-col>

      <v-col cols="12" md="4" class="py-0 my-0">
        <v-btn
          class="accent white--text"
          @click="fetchReport()"
          :loading="loading"
        >
          Search
        </v-btn>
        <v-btn class="accent white--text ml-2" @click="download">
          <v-icon>mdi-download</v-icon> Download
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="reportData?.fee?.length">
      <v-col cols="12" class="text-center py-0">
        <span class="text-5xl font-weight-bold accent--text">
          {{ selectedFeeNames }} Collection Status as on
          {{ reportData.current_date }}
        </span>
      </v-col>
      <v-col cols="12" class="d-flex justify-center">
        <table border="1" cellpadding="15" cellspacing="0" class="text-center">
          <thead>
            <tr>
              <th class="px-2">Programme</th>
              <th v-for="key in programPartnerSummary" :key="key" class="px-2">
                {{
                  key != "received_percentage" ? formatKey(key) : "Received %"
                }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, index) in reportData.fee"
              :key="index"
              :class="{
                'highlight-row': isTotalRow(item.program_name),
              }"
            >
              <th
                class="px-2"
                :class="{
                  'right-align-row': isTotalRow(item.program_name),
                }"
              >
                {{ item.program_name }}
              </th>
              <td
                v-for="key in programPartnerSummary"
                :key="key"
                style="min-width: 70px"
              >
                {{ item[key] ? formatValue(item[key], true) : 0 }}
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
    <v-row v-if="!reportData?.fee?.length" align="center" class="px-4">
      <v-col cols="12" class="d-flex justify-center position-relative">
        <span class="text-h6"> No Data Found</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      form: {
        misc_fee_ids: [],
      },
      reportData: { fee: [], current_date: null },
      examBatches: [],
      programPartnerSummary: [
        "fee_raised_count",
        "fee_raised_value",
        "fee_received_count",
        "fee_received_value",
        "received_percentage",
      ],
      feeTypes: [],
      batches: [],
      miscellaneousFees: [],
      loading: false,
    };
  },
  computed: {
    selectedFeeNames() {
      if (!this.form.misc_fee_ids.length) return "All Documents";
      return this.feeTypes
        .filter((f) => this.form.misc_fee_ids.includes(f.id))
        .map((f) => f.text)
        .join(", ");
    },
  },
  async created() {
    this.$store.commit("setBreadcrumbs", [{ text: "Requests Fee report" }]);
    // await this.generateExamBatchList();
    await this.generateBatchList();
    await this.getMiscelleaneousFees();
    await this.fetchReport();
  },
  methods: {
    async getMiscelleaneousFees() {
      try {
        const res = await this.$axios.get("/miscellaneous_fees");
        this.miscellaneousFees = res.data.data;
        this.feeTypes = this.miscellaneousFees
          .sort((a, b) => a.id - b.id)
          .map((f) => ({ id: f.id, text: f.particular }));
        this.feeTypes.push({ id: "Search Fee", text: "Search Fee" });
        this.feeTypes.push({ id: "Postal Fee", text: "Postal Fee" });
      } catch (error) {
        console.log(error);
      }
    },
    isTotalRow(code) {
      return code.includes("Total");
    },
    formatKey(key) {
      let newKey = key;
      let keyList = key.split("_");
      newKey = newKey
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());

      if (keyList.includes("amount") || keyList.includes("value"))
        return newKey + " (₹)";

      return newKey;
    },
    formatValue(value, amount = false) {
      if (amount) {
        return `${value.toLocaleString("en-IN")}`;
      }
      return typeof value === "number" && value % 1 !== 0
        ? value.toFixed(2)
        : value;
    },
    async fetchReport() {
      this.loading = true;
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      await this.$axios
        .get(`/get_postal_fee_report?${queryString}`)
        .then((res) => {
          this.reportData = res.data.data;
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    objectToQueryParams(obj) {
      const params = new URLSearchParams();

      Object.keys(obj).forEach((key) => {
        if (Array.isArray(obj[key])) {
          obj[key].forEach((v) => params.append(`${key}[]`, v));
        } else if (
          obj[key] !== undefined &&
          obj[key] !== null &&
          obj[key] !== ""
        ) {
          params.append(key, obj[key]);
        }
      });

      return params.toString();
    },
    async download() {
      const queryString = this.objectToQueryParams({
        ...this.form,
      });
      this.$axios
        .get(`/download_mis_postal_fee_report?${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: "text/csv" }),
            url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Fee Report.csv");
          document.body.appendChild(link);
          link.click();
        });
    },
    async generateBatchList() {
      try {
        const response = await this.$axios.get("/get_year_batch");
        this.batches = response.data.data;
        // this.form.year_batch = this.batches[0];
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.right-align-row {
  text-align: right;
}
.highlight-row {
  background-color: #f2f2f2 !important; /* light grey */
  font-weight: bold;
}
</style>
